import { useState, useEffect } from 'react';

function CountdownTimer({ countDown,show }) {

  


  return (
   
    <div style={{ color: !show  ? 'red' : 'inherit' }}>
      {show ? (
        <div>
         {countDown}
        </div>
      ) : (
        <div>Deadline has passed!</div>
      )}
    </div>
  );
}

export default CountdownTimer